/**
 * Who raised the document -- not who is looking at it.
 *
 * Every Screen 1 used to fill its Issuer box from the logged-in user on every
 * render, so opening a saved invoice showed the *viewer's* name. The stored
 * issuer was on the API payload the whole time; the screen loaders just never
 * copied it. (Task: invoice-issuer-shows-viewer.)
 *
 * storedIssuerName is the API's `issuer_name`, or `created_by_name` on purchase
 * orders, which carry no issuer FK at all. Older rows can have no issuer
 * recorded -- say so rather than substituting a plausible name.
 */

export const ISSUER_NOT_RECORDED = '—';

export function resolveIssuerName({ isPersisted, storedIssuerName, sessionUserName }) {
  if (isPersisted) {
    return (storedIssuerName || '').trim() || ISSUER_NOT_RECORDED;
  }
  // Nothing saved yet, so the person filling the form really is the issuer.
  return (sessionUserName || '').trim();
}

export default resolveIssuerName;
